import type { TrackingEvent, TrackingPayload } from '~/types/tracking'

type TrackNavigationType = 'main' | 'side' | 'flyout' | 'header' | 'footer'

const useNavigationEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => {
  const trackNavigation = (
    navigation_type: TrackNavigationType,
    navigation_point: string,
    navigation_level: number,
  ) =>
    track('navigation_click', {
      navigation_type,
      navigation_point,
      navigation_level,
    })

  return {
    trackNavigationMain: (navigationPoint: string) =>
      trackNavigation('main', navigationPoint, 1),

    trackNavigationSide: (navigationPoint: string, navigationLevel: number) =>
      trackNavigation('side', navigationPoint, navigationLevel),

    trackNavigationFlyout: (navigationPoint: string, navigationLevel: number) =>
      trackNavigation('flyout', navigationPoint, navigationLevel),

    trackNavigationHeader: (navigationPoint: string) =>
      trackNavigation('header', navigationPoint, 1),

    trackNavigationFooter: (navigationPoint: string) =>
      trackNavigation('footer', navigationPoint, 1),
  }
}

export default useNavigationEvents
